












































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ProjectService as _projectService } from '@/services/project.service'
import { UserService as _userService } from '@/services/user.service'
import { TemplateService as _templateService } from '@/services/template.service'
import { ProjectDto } from '@/models/dtos/projectDto'
import { UserDto } from '@/models/dtos/userDto'
import { TemplateDto } from '@/models/dtos/templateDto'
import { EProjectStatus } from '@/models/dtos/enums/eProjectStatus'
import { ETemplateType } from '@/models/dtos/enums/eTemplateType'
import { mixins } from 'vue-class-component'
import { SelectMixin } from '@/mixins/SelectMixin'
import { UserMixin } from '@/mixins/userMixin'
import { use } from 'vue/types/umd'
import { SelectDto } from '@/models/dtos/selectDto'
import SelectUserModal from '@/modals/SelectUser.modal.vue'
import WorkbookEntryModal from '@/modals/WorkbookEntry.modal.vue'
import { ValidationObserver } from 'vee-validate'
import router from '@/router'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'
import { PaginationDto } from '@/models/dtos/paginationDto'
import { WorkbookService as _workbookService } from '@/services/workbook.service'
import moment from 'moment'
import { ProjectAttachmentDto } from '@/models/dtos/projectAttachmentDto'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import { AuthService as _authService } from '@/services/auth.service'
import { EUserRole } from '@/models/dtos/enums/eUerRole'
import DatePicker from 'vue2-datepicker'
import { WorkbookEntryFiltersDto } from '@/models/dtos/workbookEntryFiltersDto'
import { EUserStatus } from '@/models/dtos/enums/eUserStatus'

@Component({
  components: {
    SelectUserModal,
    WorkbookEntryModal,
    DatePicker
  }
})
export default class ProjectCreateOrUpdate extends mixins(SelectMixin, UserMixin) {
  // Refs
  $refs!: {
    projectForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private currentUser: UserInfoDto | null = null
  private projectId: string | null = null
  private project: ProjectDto | null = null
  private users: UserDto[] | null = null
  private templates: TemplateDto[] | null = null
  private projectStatuses: SelectDto[] = []

  // Workbok Tab
  private workbookFilters: WorkbookEntryFiltersDto = { name: '', startDate: null, endDate: null }
  private workbookEntries: PagedResponseDto<WorkbookEntryDto> | null = null
  private workbookItems: { id: string; date: string; user: string; message: string; time: string }[] = []
  private workbookFields = [
    { key: 'date', label: 'Data', class: 'align-middle' },
    { key: 'user', label: 'Użytkownik', class: 'align-middle' },
    { key: 'message', label: 'Wiadomość', class: 'align-middle' },
    { key: 'time', label: 'Godziny pracy', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Attachment Tab
  private attachments: ProjectAttachmentDto[] = []
  private attachmentItems: { id: string; date: string; user: string; filename: string; description: string }[] = []
  private attachmentFields = [
    { key: 'date', label: 'Stworzono', class: 'align-middle' },
    { key: 'user', label: 'Stworzono przez', class: 'align-middle' },
    { key: 'filename', label: 'Nazwa pliku', class: 'align-middle text-break' },
    { key: 'description', label: 'Opis', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  private attachmentPagination: PaginationDto = {
    pageSize: 15,
    pageNumber: 1
  }

  // Methods
  private async init() {
    // Set current user
    _authService.currentUser().subscribe(userInfo => {
      this.currentUser = userInfo
    })

    this.users = await _userService.getUsers()
    await this.initTemplates()
    await this.initProject()

    // Workbook tab
    this.initWorkbookEntries()
    this.$root.$on('worbook-entry-modal-saved', this.initWorkbookEntries)

    // Attachment tab
    this.initAttachments()

    // Dropdowns
    const excludeProjectStatuses: (keyof typeof EProjectStatus)[] = []
    if (!this.currentUser?.roles.includes(EUserRole.Admin)) {
      excludeProjectStatuses.push('Closed')
    }

    this.projectStatuses = this.mapEnumToSelect(EProjectStatus, this.statusName, excludeProjectStatuses)
  }

  // Workbook entries
  private async initWorkbookEntries() {
    if (!this.projectId) return

    this.workbookEntries = await _workbookService.getProjectEntries(this.projectId, this.workbookEntries?.currentPage, this.workbookEntries?.pageSize, this.workbookFilters)
    this.workbookItems = []

    for (const entry of this.workbookEntries.items) {
      const user = this.getUser(this.users!, entry.accountId)

      this.workbookItems.push({
        id: entry.id!,
        date: moment(entry.date).format('llll'),
        user: `${user?.firstName} ${user?.lastName}`,
        message: entry.message,
        time: `${entry.startTime} - ${entry.endTime}`
      })
    }
  }

  private async removeWorkbookEntry(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten wpis', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _workbookService.removeWorkbookEntry(id)
      this.initWorkbookEntries()
    }
  }

  private async editWorkbookEntry(id: string) {
    const entry = this.workbookEntries!.items.find(e => e.id === id)
    if (entry) {
      this.$root.$emit('show-workbook-entry-modal', entry)
    }
  }

  private clearFilters() {
    this.workbookFilters = {
      startDate: null,
      endDate: null,
      name: ''
    }

    this.initWorkbookEntries()
  }

  // Attachments
  private async initAttachments() {
    if (!this.projectId) return

    this.attachments = await _projectService.getProjectAttachments(this.projectId)
    this.attachmentItems = []

    for (const entry of this.attachments) {
      const user = this.getUser(this.users!, entry.createdById)

      this.attachmentItems.push({
        id: entry.id!,
        date: moment(entry.created).format('llll'),
        user: `${user?.firstName} ${user?.lastName}`,
        description: entry.description,
        filename: entry.name
      })
    }
  }

  private async removeAttachment(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten załącznik', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _projectService.removeAttachment(id)
      this.initAttachments()
    }
  }

  // Project
  private async removeProject() {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten projekt', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderClose: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _projectService.removeProject(this.projectId!)
      router.push('/')
    }
  }

  private async initProject() {
    this.projectId = (this.$route.params as any)?.id || null

    if (!this.users) throw new Error('You have to define users')

    this.project = {
      normalizedName: '',
      nameCompanyId: this.companyTemplates[0]?.value || '',
      nameWarehouseId: this.warehouseTemplates[0]?.value || '',
      nameDate: moment().format('YYYY-MM-DD'),
      nameDescription: '',
      description: '',
      supervisorId: '',
      annual: false,
      created: new Date(),
      startDate: new Date(),
      status: EProjectStatus.Started,
      assaignedUsers: []
    }

    if (this.projectId) {
      const project = await _projectService.getProject(this.projectId) || this.project
      this.project = project
    }
  }

  private async initTemplates() {
    this.templates = await _templateService.getProjectTemplates()
  }

  private changeSupervisor(id: string) {
    if (!this.project) return
    this.project.supervisorId = id
  }

  private async createOrUpdateProject() {
    if (!this.project) return

    const isProjectFormValid = await this.$refs.projectForm.validate()
    if (!isProjectFormValid) {
      this.$notify({
        group: 'notifications',
        title: 'Projekt',
        text: 'Proszę uzupełnić wymagane pola!',
        type: 'error'
      })

      return
    }

    if (!this.project.supervisorId) {
      this.$notify({
        group: 'notifications',
        title: 'Projekt',
        text: 'Proszę wybrać kierownika projektu!',
        type: 'error'
      })

      return
    }

    if (!this.project.id) {
      const projectId = await _projectService.saveProject(this.project)
      router.push({ name: 'ProjectEdit', params: { id: projectId.toString() } })
    } else {
      _projectService.editProject(this.project)
    }
  }

  private addSelectedUsersToProject(users: string[]) {
    if (!this.project) return

    this.project.assaignedUsers.push(...users)
  }

  private removeUserFromProject(id: string) {
    if (!this.project) return

    this.project.assaignedUsers = this.project.assaignedUsers.filter(userId => userId !== id)
  }

  private addUsersToProject() {
    this.$root.$emit('show-select-user-modal', this.notAssignedUsers)
  }

  // Utili

  private getTemplate(id: string): TemplateDto {
    if (!this.templates) throw new Error('Templates not definded')

    const template = this.templates.find(t => t.id === id)
    if (!template) throw new Error('Template with given id does not exist')

    return template
  }

  // Getters

  private get isLoaded() {
    return !this.project || !this.users || !this.templates
  }

  private get companyTemplates() {
    if (!this.templates?.length) throw new Error('Templates must be defined')

    const companyTemplates = this.templates.filter(t => t.type === ETemplateType.Company)
    return this.mapObjectToSelect(companyTemplates, { value: 'id', text: (obj) => `${obj.shorthand} (${obj.fullName})` })
  }

  private get warehouseTemplates() {
    if (!this.templates?.length) throw new Error('Templates must be defined')

    const companyTemplates = this.templates.filter(t => t.type === ETemplateType.Warehouse)
    return this.mapObjectToSelect(companyTemplates, { value: 'id', text: (obj) => `${obj.shorthand} (${obj.fullName})` })
  }

  private get supervisorOptions() {
    if (!this.project?.assaignedUsers) throw new Error('User must be defined')

    const availableUsers = this.users!.filter(u => this.project!.assaignedUsers.includes(u.id))
    const res = this.mapObjectToSelect(availableUsers, {
      value: 'id',
      text: (obj) => `${obj.firstName} ${obj.lastName}`
    })

    if (!this.project.supervisorId) {
      const defaultSelect: SelectDto = { text: 'Proszę wybrać z listy', value: '' }
      res.unshift(defaultSelect)
    }

    return res
  }

  private get assignedUsers() {
    return this.users!.filter(u => this.project!.assaignedUsers.includes(u.id))
  }

  private get notAssignedUsers() {
    return this.users!.filter(u => u.status === EUserStatus.Active &&
                                !this.project!.assaignedUsers.includes(u.id))
  }

  // Lifecycle
  async created() {
    this.init()
  }

  // Watches
  @Watch('$route')
  async onRouteChange() {
    this.init()
  }
}
